<template>
  <div>
    <v-container fluid class="my-0 py-0">
      <v-card class="mt-3" :elevation="8">
        <Avanzamento
          :autocontrolli_allowed="autocontrolli_allowed"
          :causali_allowed="causali_allowed"
          :contenitori_allowed="contenitori_allowed"
          :pezzi_allowed="pezzi_allowed"
          :pezzi_insit_allowed="pezzi_insit_allowed"
          :scarti_allowed="scarti_allowed"
          :tempi_allowed="tempi_allowed"
          :tempi_squadra_allowed="tempi_squadra_allowed"
          :tracciabilita_allowed="tracciabilita_allowed"
        />
      </v-card>
    </v-container>
  </div>
</template>
<script>
import Avanzamento from "@/views/PRODUCTION/Avanzamento/Avanzamento.vue";

export default {
  name: "AvanzamentoInsitAdapter",
  props: [],
  components: {
    Avanzamento,
  },
  data() {
    return {
      // Variabili d'appoggio
      autocontrolli_allowed: true,
      causali_allowed: true,
      contenitori_allowed: true,
      pezzi_allowed: false,
      pezzi_insit_allowed: true,
      scarti_allowed: true,
      tempi_allowed: true,
      tempi_squadra_allowed: false,
      tracciabilita_allowed: false,

      // Modal

      // Array
    };
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
